import { PartnershipConfig } from '@/types/partnership.types';
import { ashokaPartnership } from './ashoka';
import { euroleaderPartnership } from './euroleader';

export const partnerships: Record<string, PartnershipConfig> = {
  ashoka: ashokaPartnership,
  euroleader: euroleaderPartnership,
};

export const getPartnership = (id: string): PartnershipConfig | null => {
  return partnerships[id] || null;
};

export const getPartnershipIds = (): string[] => {
  return Object.keys(partnerships);
};

